<template>
  <div>
    <!-- Latest News Section -->
    <section class="latest-news">
      <h2 class="section-title big white">产品速览</h2>

      <div class="cards-row">
        <div v-for="(card, index) in cards" :key="index" class="card">
          <div class="card-overlay">
            <div class="card-content">
              <div class="icon-container">
                <el-icon
                  class="sidebar-icon"
                  :style="{ 'font-size': '1.6rem' }"
                >
                  <component :is="card.icon" class="icon" />
                </el-icon>
              </div>
              <h3 class="card-title">{{ card.title }}</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="footer">
      <div class="container">
        <!-- 链接部分 -->
        <div class="footer-links">
          <!-- 公司信息 -->
          <div class="footer-column">
            <h3 class="column-title">Company</h3>
            <ul class="link-list">
              <li><nuxt-link to="/page/About-Us">About Us</nuxt-link></li>
              <li>
                <nuxt-link to="/page/Contact-Us">Contact Us</nuxt-link>
              </li>
              <li>
                <nuxt-link to="/page/Company-News">Company News</nuxt-link>
              </li>
            </ul>
          </div>

          <!-- 产品和服务 -->
          <div class="footer-column">
            <h3 class="column-title">Products & Services</h3>
            <ul class="link-list">
              <li>
                <nuxt-link to="/page/OEM-Services">Equipments</nuxt-link>
              </li>
              <li>
                <nuxt-link to="/page/Factory-Services">Factories</nuxt-link>
              </li>
              <li>
                <nuxt-link to="/page/Test-Applications">Application</nuxt-link>
              </li>
              <!-- <li>
                <nuxt-link to="/page/Embedded-Device">
                  Embedded Device
                </nuxt-link>
              </li> -->
            </ul>
          </div>

          <!-- 资源 -->
          <div class="footer-column">
            <h3 class="column-title">Resources</h3>
            <ul class="link-list">
              <li>
                <nuxt-link to="/page/SEMI-Standards">SEMI Standard</nuxt-link>
              </li>
              <li>
                <nuxt-link to="/page/SEMI-News">SEMI News</nuxt-link>
              </li>
            </ul>
          </div>

          <!-- 联系我们 -->
          <div class="footer-column">
            <h3 class="column-title">Contact Us</h3>
            <div class="contact-info">
              <p class="phone">
                <el-icon><Phone /></el-icon>
                14761138401
              </p>
              <p class="address">
                <el-icon><Location /></el-icon>
                <span> 江苏省常州市湖塘科技产业园B1-405 </span>
              </p>
              <p class="address">
                <el-icon><Message /></el-icon>
                <span> info@modulemotion.com </span>
              </p>
            </div>
          </div>
        </div>
        <div class="footer-copyright">
          Copyright @微著系统（常州）有限公司
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >苏ICP备2025174716号-1</a
          >
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { Phone, Location, Message } from "@element-plus/icons-vue";
import { CircleCheck, Setting } from "@element-plus/icons-vue";
const cards = ref([
  {
    title: "DLink Driver V2.0.2",
    image:
      "https://images.unsplash.com/photo-1563770660941-10a63a9ed40d?q=80&w=600",
    icon: CircleCheck,
  },
  {
    title: "支持limit monitor功能",
    icon: CircleCheck,
  },
  {
    title: "MAT 1.0.2",
    image:
      "https://images.unsplash.com/photo-1518770660967-092e0a45ddbb?q=80&w=600",
    icon: CircleCheck,
  },
  {
    title: "支持 SEMI标准 E116",
    image:
      "https://images.unsplash.com/photo-1518770660967-092e0a45ddbb?q=80&w=600",
    icon: CircleCheck,
  },
  {
    title: "支持spooling message功能",
    image: "~/assets/images/indianapolis-skyline.jpg",
    icon: CircleCheck,
  },
]);
</script>

<style lang="scss" scoped>
.section-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-align: left;
  &.white {
    color: white;
  }

  &.big {
    font-size: 60px;
    text-align: center;
  }
}
.icon-container {
  background-color: rgba(255, 255, 255, 0.9);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  font-size: 28px;
}
.icon-container .icon {
  color: #333;
  width: 24px;
  height: 24px;
}
@media (max-width: 768px) {
  .section-title {
    font-size: 1.5rem;
  }
}
/* Latest News Section */
.latest-news {
  padding: 2rem 2rem 5rem;
  background-image: url(~/assets/images/product-bg.jpg);
  background-size: cover;
}
.cards-row {
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  overflow-x: auto;
  padding: 1rem;
  scrollbar-width: thin;
  width: calc(#{$maxWidth});
  margin: 0 auto;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.cards-row::-webkit-scrollbar {
  height: 6px;
}

.cards-row::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.cards-row::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.cards-row::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.card {
  position: relative;
  flex: 0 0 calc(16.666% - 0.833rem); /* 6 cards in a row with gap consideration */
  min-width: 220px; /* Minimum width for smaller screens */
  height: 400px;
  border-radius: 0;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  transition: transform 0.5s ease;
  cursor: pointer;
  border: 1px solid #fff;
  &:nth-child(1) {
    background-image: url(~/assets/images/product-1-new.jpg);
  }
  &:nth-child(2) {
    background-image: url(~/assets/images/product-2-new.jpg);
  }
  &:nth-child(3) {
    background-image: url(~/assets/images/product-3-new.jpg);
  }
  &:nth-child(4) {
    background-image: url(~/assets/images/product-4-new.jpg);
  }
  &:nth-child(5) {
    background-image: url(~/assets/images/product-5-new.jpg);
  }
  &:hover {
    transform: scale(1.05);
    z-index: 1;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  }
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.1),
    rgba(0, 0, 0, 0.8)
  );
  display: flex;
  flex-direction: column;
  padding: 6rem 1.5rem 1.5rem;
  box-sizing: border-box;
}

.card-content {
  color: white;
  text-align: center;
}

.card-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
}

/* For larger screens, ensure all 6 cards fit in one row */
@media (min-width: 1400px) {
}

/* For medium screens, show fewer cards but keep them in a row with scroll */
@media (max-width: 1200px) {
  .card {
    flex: 0 0 calc(25% - 0.75rem); /* 4 visible cards */
  }
}

@media (max-width: 768px) {
  .card {
    flex: 0 0 calc(33.333% - 0.667rem); /* 3 visible cards */
  }
}

@media (max-width: 480px) {
  .card {
    flex: 0 0 calc(85% - 0.5rem); /* Almost full width for mobile */
  }
}

.footer {
  background-color: #1a1a1a;
  color: #ffffff;
  padding: 2rem 0;
  font-family: Arial, sans-serif;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

/* 搜索部分 */
.search-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3rem;
  flex-wrap: wrap;
}

.search-title {
  font-size: 1.8rem;
  font-weight: 500;
  margin: 0;
  flex: 1;
  min-width: 300px;
}

.search-input-container {
  position: relative;
  max-width: 300px;
  width: 100%;
}

.search-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  border: none;
  font-size: 1rem;
}

.search-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #333;
}

/* 链接部分 */
.footer-links {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
}
.footer-copyright {
  color: #c1c1c1;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s;
  line-height: 2rem;
  a {
    color: #c1c1c1 !important;
  }
}
.footer-column {
  margin-bottom: 1.5rem;
}

.column-title {
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #3a7bd5;
}

.link-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.link-list li {
  margin-bottom: 0.5rem;
}

.link-list a {
  color: #c1c1c1;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s;
}

.link-list a:hover {
  color: #3a7bd5;
}

.support-section {
  margin-top: 2rem;
}

/* 社交图标 */
.social-icons {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.social-icon {
  color: #ffffff;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-icon {
  font-size: 1.2rem;
}

/* 联系信息 */
.contact-info {
  font-size: 0.9rem;
  line-height: 1.5;
}

.phone,
.address {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .search-section {
    flex-direction: column;
    align-items: flex-start;
  }

  .search-title {
    margin-bottom: 1rem;
  }

  .search-input-container {
    max-width: 100%;
  }

  .footer-links {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
}

@media (max-width: 480px) {
  .footer-links {
    grid-template-columns: 1fr;
  }
}
</style>
